import { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { AppLogoIcon } from '../../icons/AppLogoIcon'
import { StyledMobileIcon } from '../../icons/MobileIcon'
import { mpInit, mpTrackClickHereCta } from '../../tracking/mixpanel'
import {
    selectClickHereCtaLink,
    selectClickHereCtaText,
    selectListenOnText,
    setApplicationOptions,
} from '../application/applicationSlice'
import { ArticleWidgetPlayer } from '../article/components/ArticleWidgetPlayer'
import { fetchArticleByIdThunk, selectCurrentlyPlayingArticle, selectLinkToNoa } from '../article/data/articleSlice'
import { AudioPlayer } from '../audio/AudioPlayer'
import { selectTheme, setTheme } from '../theme/data/themeSlice'
import themeUtils from '../theme/data/themeUtils'
import { AppIconAndHyperlinkContainer } from './styled/AppIconAndHyperlinkContainer.styled'
import { MoreArticlesText } from './styled/MoreArticlesText'
import { PoweredBy } from './styled/PoweredBy'
import { WebsiteHyperlink } from './styled/WebsiteHyperlink.styled'
import { WebsiteHyperlinkContainer } from './styled/WebsiteHyperlinkContainer.styled'
import { WebsiteHyperlinkText } from './styled/WebsiteHyperlinkText.styled'
import { WidgetFixedHeader } from './styled/WidgetFixedHeader.styled'
import { ArticleWidgetContainer } from './styled/ArticleWidgetContainer'
import { StyledDivider } from './styled/StyledDivider'

export const ArticleWidget = () => {
    const dispatch = useAppDispatch()

    const theme = useAppSelector(selectTheme)
    const linkToNoa = useAppSelector(selectLinkToNoa)
    const clickHereCtaText = useAppSelector(selectClickHereCtaText)
    const listenOnText = useAppSelector(selectListenOnText)
    const clickHereCtaLink = useAppSelector(selectClickHereCtaLink)
    const currentlyPlayingArticle = useAppSelector(selectCurrentlyPlayingArticle)

    useEffect(() => {
        dispatch(fetchArticleByIdThunk())
        dispatch(setTheme())
        dispatch(setApplicationOptions())
        mpInit()
    }, [])

    return (
        <ThemeProvider theme={{ ...theme, ...themeUtils }}>
            <ArticleWidgetContainer>
                <WidgetFixedHeader isArticleWidget={true}>
                    <div style={{ padding: '0px 15px' }}>
                        <WebsiteHyperlink href={linkToNoa} target='_blank'>
                            <AppIconAndHyperlinkContainer>
                                <PoweredBy>
                                    <AppLogoIcon height={24} width={65} />
                                </PoweredBy>
                                <WebsiteHyperlinkContainer>
                                    <WebsiteHyperlinkText>{listenOnText}</WebsiteHyperlinkText>
                                    <StyledMobileIcon />
                                </WebsiteHyperlinkContainer>
                            </AppIconAndHyperlinkContainer>
                        </WebsiteHyperlink>
                    </div>
                    <StyledDivider />

                    {currentlyPlayingArticle != null && <ArticleWidgetPlayer article={currentlyPlayingArticle} />}
                </WidgetFixedHeader>

                <AudioPlayer />
                <MoreArticlesText
                    isArticleWidget={true}
                    href={clickHereCtaLink}
                    onClick={() => mpTrackClickHereCta(currentlyPlayingArticle)}
                    target='_black'>
                    {clickHereCtaText}
                </MoreArticlesText>
            </ArticleWidgetContainer>
        </ThemeProvider>
    )
}
